import { useEffect, useState } from 'react';
import { AutoTooltip } from '../../../../components/auto-tooltip';
import { CompanyRejectTypeLabelMap } from '../../../../config/company';
import { strToJson } from '../../../../lib';
import getFormatMessage from '../../../../locales/get-format-message';
import { ICompanyRejectType } from '../../../../model';
import {
  CommonStatusStep,
  IAPICompanyFullInfo,
  MDMAuthStatus,
  StudioCertifiedType,
} from '../../../../model/api-modules';
import { getCompanyFileUrl } from '../../lib/company-cos';

import { UploadCert } from '../company-drawer/upload';
import { CertInfoViewPanel } from './cert-info';
import styles from './index.module.scss';

interface IProps {
  certUrl?: string;
  data?: IAPICompanyFullInfo;
  showRejectReasons?: boolean;
}

export const CompanyInfoViewPanel = (props: IProps) => {
  const { data: companyInfo, certUrl, showRejectReasons = false } = props;

  const [licenseUrl, setLicenseUrl] = useState<string>('');

  useEffect(() => {
    init();
  }, [companyInfo]);

  const init = async () => {
    if (!companyInfo) {
      return;
    }
    const licenseImageUrl =
      certUrl ||
      (await getCompanyFileUrl(companyInfo?.BusinessLicenseImageUrl));

    setLicenseUrl(licenseImageUrl);
  };

  const contactInfo = companyInfo?.Contacts?.split('|') || [];
  const viewInfo: Record<string, Record<string, string | undefined>> = {
    [getFormatMessage('company_info')]: {
      [getFormatMessage('company_name')]: companyInfo?.Name,
      [getFormatMessage('company_credit_code')]: companyInfo?.CreditCode,
      [getFormatMessage('company_area')]: getFormatMessage('company_area_cn'),
      [getFormatMessage('company_desc')]: companyInfo?.Description,
    },
    [getFormatMessage('company_contact_man')]: {
      [getFormatMessage('company_contact_name')]: contactInfo[0],
      [getFormatMessage('company_contact_id')]: contactInfo[1],
      [getFormatMessage('company_contact_phone')]: `+86 ${contactInfo[2]}`,
    },
  };

  const getRejectReasons = () => {
    if (!companyInfo) {
      return '';
    }
    const rejectArray =
      strToJson<Array<any>>(companyInfo.ManualRejectReason || '') || [];

    let rejectItemLabels = rejectArray.map((rejectItem) => {
      return (
        CompanyRejectTypeLabelMap[rejectItem.type as ICompanyRejectType] +
        rejectItem.reason
      );
    });

    if (
      !rejectItemLabels.length &&
      companyInfo.MDMStatus === MDMAuthStatus.ApprovalFailed
    ) {
      const mdmRejectReason =
        strToJson<{ code?: number; msg?: string }>(
          companyInfo.MDMRejectReason || ''
        ) || {};
      rejectItemLabels = [getFormatMessage(String(mdmRejectReason.code || ''))];
    }

    return rejectItemLabels.join();
  };

  if (companyInfo?.certifiedType === StudioCertifiedType.InternalKpiCode) {
    return <CertInfoViewPanel data={companyInfo} />;
  }

  return (
    <div>
      <div className={styles.infoPanel}>
        <UploadCert disabled={true} value={{ url: licenseUrl }} />

        <div className={styles.infoContent}>
          {Object.keys(viewInfo).map((title) => {
            const subTitles = Object.keys(viewInfo[title]);
            return (
              <>
                <div className={styles.infoTitle}>{title}</div>

                {subTitles.map((subTitle) => {
                  const valueText = viewInfo[title][subTitle] || '--';

                  return (
                    <div className={styles.infoItem}>
                      <span className={styles.infoSubTitle}>{subTitle}</span>
                      <AutoTooltip title={valueText} placement="topLeft">
                        <span className={styles.infoValue}>{valueText}</span>
                      </AutoTooltip>
                    </div>
                  );
                })}
              </>
            );
          })}
        </div>
      </div>
      {showRejectReasons && companyInfo?.Status === CommonStatusStep.Reject && (
        <div className={styles.rejectReason} style={{ marginLeft: 200 }}>
          拒绝原因: {getRejectReasons()}
        </div>
      )}
    </div>
  );
};
